export default __webpack_public_path__ + "static/media/accidents.20d6d1ce.svg";